import React from 'react';
import { Box, Chip, Skeleton, Stack, Typography } from '@mui/material';
import { baseColors } from '../../../Themes/colors';
export var isAspireSource = function (source) { return String(source !== null && source !== void 0 ? source : '').trim().toUpperCase() === 'ASPIRE'; };
export var getReasonSourceLabel = function (source, isCustom, fallback) {
    if (isAspireSource(source))
        return 'Aspire';
    if (isCustom)
        return 'Custom';
    if (String(source !== null && source !== void 0 ? source : '').trim().toUpperCase() === 'HUB')
        return 'Predefined';
    return fallback;
};
export var findStatusReason = function (reason, statusReasons) {
    if (reason.oid)
        return statusReasons.find(function (candidate) { return candidate.reasonOId === reason.oid; });
    return reason.lookupId ? statusReasons.find(function (candidate) { return String(candidate.id) === reason.lookupId; }) : undefined;
};
export var toContractNoticeItems = function (contractReasons, statusReasons) {
    return contractReasons.map(function (reason) {
        if (!statusReasons)
            return { text: reason.text, source: isAspireSource(reason.source) ? 'Aspire' : undefined, isPending: true };
        var match = findStatusReason(reason, statusReasons !== null && statusReasons !== void 0 ? statusReasons : []);
        return { text: reason.text, source: getReasonSourceLabel(reason.source, match === null || match === void 0 ? void 0 : match.isCustom, 'Aspire'), documentType: match === null || match === void 0 ? void 0 : match.documentType };
    });
};
var sourceBadgeStyles = {
    Aspire: { bg: '#E8F1FE', color: baseColors.bluePreset[50], border: baseColors.bluePreset[20] },
    Predefined: { bg: '#E7F6F1', color: baseColors.successPreset[10], border: baseColors.successPreset[60] },
    Custom: { bg: '#FDF3E7', color: '#B4690E', border: '#F5D7B0' },
};
var SourceBadge = function (_a) {
    var source = _a.source, isPending = _a.isPending;
    if (!source)
        return isPending ? React.createElement(Skeleton, { variant: "rounded", width: 76, height: 20, sx: { flexShrink: 0, borderRadius: 1 } }) : null;
    var style = sourceBadgeStyles[source];
    return (React.createElement(Box, { component: "span", sx: {
            px: 1.25,
            py: 0.25,
            borderRadius: 1,
            fontSize: 11,
            fontWeight: 600,
            bgcolor: style.bg,
            color: style.color,
            border: "1px solid ".concat(style.border),
            minWidth: 76,
            textAlign: 'center',
            flexShrink: 0,
        } }, source));
};
export var DocumentTypeTag = function (_a) {
    var label = _a.label;
    return (React.createElement(Box, { component: "span", sx: {
            px: 1,
            py: 0.25,
            borderRadius: 1,
            fontSize: 11,
            fontWeight: 600,
            bgcolor: baseColors.greyPreset[60],
            color: baseColors.greyPreset[10],
            border: "1px solid ".concat(baseColors.greyPreset[40]),
            whiteSpace: 'nowrap',
        } }, label));
};
var ReasonsNoticePreview = function (_a) {
    var items = _a.items;
    return (React.createElement(Box, { sx: { border: "1px solid ".concat(baseColors.bluePreset[10]), borderRadius: 2, p: 2, width: '100%' } },
        React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", mb: 1.5 },
            React.createElement(Stack, { direction: "row", alignItems: "baseline", gap: 1 },
                React.createElement(Typography, { variant: "body2", fontWeight: 700, color: baseColors.bluePreset[10] }, "Notice preview"),
                React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[5] }, "How the reasons appear in the dealer's email")),
            React.createElement(Chip, { label: "".concat(items.length, " ").concat(items.length === 1 ? 'reason' : 'reasons'), size: "small", sx: { bgcolor: baseColors.bluePreset[10], color: baseColors.fullWhite, fontWeight: 600, fontSize: 11, height: 22 } })),
        React.createElement(Box, { sx: { border: "1px solid ".concat(baseColors.greyPreset[60]), borderRadius: 1.5, px: 2, py: 1.5 } },
            React.createElement(ReasonsChipList, { items: items, emptyText: "No reasons added yet." }))));
};
export default ReasonsNoticePreview;
export var ReasonsChipList = function (_a) {
    var items = _a.items, _b = _a.emptyText, emptyText = _b === void 0 ? '--' : _b;
    return (items.length > 0 ? (React.createElement(Stack, { component: "ul", gap: 1, sx: { m: 0, pl: 2 } }, items.map(function (item, index) { return (React.createElement(Box, { component: "li", key: "".concat(item.source, "-").concat(item.text, "-").concat(index) },
        React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", gap: 2 },
            React.createElement(Stack, { direction: "row", alignItems: "center", flexWrap: "wrap", gap: 1, sx: { minWidth: 0 } },
                React.createElement(Typography, { variant: "body2", color: baseColors.darkPreset[10], sx: { wordBreak: 'break-word' } }, item.text),
                item.isPending
                    ? React.createElement(Skeleton, { variant: "rounded", width: 72, height: 20, sx: { borderRadius: 1 } })
                    : item.documentType && React.createElement(DocumentTypeTag, { label: item.documentType })),
            React.createElement(SourceBadge, { source: item.source, isPending: item.isPending })))); }))) : (React.createElement(Typography, { variant: "body2", color: baseColors.greyPreset[5] }, emptyText)));
};
export var toSourcedReasons = function (statusReasons) {
    return (Array.isArray(statusReasons) ? statusReasons : [])
        .filter(function (reason) { return typeof (reason === null || reason === void 0 ? void 0 : reason.Value) === 'string' && reason.Value.trim().length > 0; })
        .map(function (reason) { return ({
        id: (reason === null || reason === void 0 ? void 0 : reason.Id) !== undefined && (reason === null || reason === void 0 ? void 0 : reason.Id) !== null ? String(reason.Id) : undefined,
        oid: (reason === null || reason === void 0 ? void 0 : reason.OId) !== undefined && (reason === null || reason === void 0 ? void 0 : reason.OId) !== null && String(reason.OId).trim() !== '' ? String(reason.OId).trim() : undefined,
        lookupId: (reason === null || reason === void 0 ? void 0 : reason.LookupId) !== undefined && (reason === null || reason === void 0 ? void 0 : reason.LookupId) !== null && String(reason.LookupId).trim() !== '' ? String(reason.LookupId).trim() : undefined,
        text: reason.Value,
        source: reason === null || reason === void 0 ? void 0 : reason.Source,
    }); });
};
